/* eslint-disable no-template-curly-in-string */
import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { connect } from 'react-redux'

import {
  pipe,
  cond,
  gte,
  not,
  defaultTo,
  length,
  splitAt,
  identity,
  join,
  toString,
  T
} from 'ramda'
import ExpandingTextArea from 'components/form/textarea'
import withFieldError from 'components/form/with-error'
import withTooltip from 'components/form/with-tooltip'
import MediaUploadButton, { MediaThumbnails } from './media'
import DmAttachments from './dm-attachments/'
import './tweet-input.css'
import {
  validateTweet,
  validateBlastTweet,
  validateDm,
  validateAttachment,
  validateCardUri
} from './validation'
import { mapStateToProps } from './util'

export const formatDmTextLength = pipe(
  defaultTo(''),
  length,
  cond([
    [pipe(gte(3), not), pipe(toString, splitAt(-3), join(' '))],
    [T, pipe(identity, toString)]
  ])
)

const tweetLength = (text, isTriggerBlast) => {
  let textLength = window.twttr.txt.parseTweet(text).weightedLength
  if (isTriggerBlast) textLength += 17
  return textLength
}

const getTweetInputPlaceholder = isTriggerBlast => {
  if (isTriggerBlast) {
    return 'User handle will occupy 17 characters'
  }
  return 'Enter Message.'
}

export const TweetInput = ({
  isDM,
  isTriggerBlast,
  input,
  meta: { error, touched }
}) => (
  <div className='br-tweet-input'>
    <ExpandingTextArea
      className={
        'form-control custom-text-area no-borders ' +
        (error && touched ? 'has-error' : '')
      }
      placeholder={getTweetInputPlaceholder(isTriggerBlast)}
      label='Tweet Message'
      {...input}
    />

    <Field
      component={MediaThumbnails}
      name={input.name.replace(/\.\w+$/, '.media')}
      format={value => value || []}
    />

    <div className='pull-right' style={{ color: 'black' }}>
      {!isDM
        ? tweetLength(input.value || '', isTriggerBlast) + ' / 280'
        : formatDmTextLength(input.value) + ' / 10 000'}
    </div>
  </div>
)

TweetInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any,
  name: PropTypes.string,
  isDM: PropTypes.bool,
  isTriggerBlast: PropTypes.bool
}

export const UrlInput = ({ input, placeholder, meta: { touched, error } }) => {
  return (
    <div>
      <input
        {...input}
        placeholder={placeholder}
        type='url'
        className={
          'form-control br-url-input ' + (error && touched ? 'has-error' : '')
        }
      />
    </div>
  )
}

UrlInput.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const TweetInputWithError = withFieldError(TweetInput)
const UrlWithError = withFieldError(UrlInput)

export const TweetField = ({
  isDM,
  isTriggerBlast,
  isTweet,
  isOverlay,
  messageName,
  urlName,
  cardUriName,
  mediaName,
  media,
  attachmentUrl,
  cardUri,
  validate = () => {}
}) => {
  return (
    <div className='br-tweet-container'>
      <Field
        component={TweetInputWithError}
        validate={
          isDM
            ? validateDm
            : isTriggerBlast
            ? validateBlastTweet
            : validateTweet
        }
        name={messageName}
        isDM={isDM}
        isTriggerBlast={isTriggerBlast}
      />

      {isOverlay ? null : (
        <Field
          component={withTooltip(MediaUploadButton)}
          tooltipTitle='Add media'
          type='button'
          name={messageName.replace(/\.\w+$/, '.media')}
          format={value => value || []}
          isDM={isDM}
        />
      )}

      {isDM || isOverlay ? null : (
        <Field
          component={UrlWithError}
          type='url'
          validate={validateAttachment(media, cardUri)}
          name={urlName}
          placeholder='Attachment URL'
        />
      )}

      {isDM || isOverlay ? null : (
        <Field
          component={UrlWithError}
          type='url'
          validate={validateCardUri(media, attachmentUrl)}
          name={cardUriName}
          placeholder='card://123456789012345678'
        />
      )}

      {isDM || isTriggerBlast ? (
        <DmAttachments name={messageName.replace(/\.\w+$/, '')} />
      ) : null}
    </div>
  )
}

TweetField.propTypes = {
  messageName: PropTypes.string,
  urlName: PropTypes.string,
  cardUriName: PropTypes.string,
  isDM: PropTypes.bool,
  isTriggerBlast: PropTypes.bool,
  isTweet: PropTypes.bool,
  isOverlay: PropTypes.bool,
  validate: PropTypes.func,
  mediaName: PropTypes.string,
  media: PropTypes.any,
  attachmentUrl: PropTypes.string,
  cardUri: PropTypes.string
}

const TweetFieldMapped = connect(mapStateToProps)(TweetField)

export default TweetFieldMapped



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/index.js